<template>
  <div>
    <el-select :value="selected"  value-key="2" :size="size" :placeholder="$t('table.status')" @input="change($event)" :clearable="true">
      <el-option label="未生效" value="0" />
      <el-option label="使用中" value="1" />
      <el-option label="已用完" value="2" />
      <el-option label="已失效" value="3" />
      <el-option label="已退款" value="4" />
      <el-option label="已生效" value="5" />
    </el-select>
  </div>
</template>

<script>
export default {
  data () {
    return {
      selected: '',
      options: ['未生效', '使用中', '已用完', '已失效', '已退款', '已生效']
    }
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change: function (val) {
      this.selected = val
      this.$emit('input', this.selected)
    }
  },
  mounted () {
    this.selected = this.options[this.value]
  },
  watch: {
    value (val) {
      this.selected = this.options[this.value]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/PackageThroughStatusSelect.vue